<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->
<template>
  <v-expansion-panel class="mt-1">
    <h3 class="text-left ml-1 mt-2 trade-blue-text">Sub national share:</h3>
    <v-expansion-panel-header class="trade-blue ma-0">
      <span>
        Sub National Share
      </span>
      <span class="yellow--text caption text-right font-italic ma-0 pa-0">
        {{ advanced ? ' (advanced)' : ' (basic)' }}
      </span>
      <template v-slot:actions>
        <v-icon color="yellow">$expand</v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-2">
      <v-main class="ma-0 pa-0 filterItem">
        <v-container class="ma-0 pa-0" fluid>
          <v-row>
            <v-flex class="ma-0 pa-0 body-2 sm6 pt-0 pb-0">
              <span class="green--text text-h6 pt-5">
                {{ true > 0 ? '✓' : '' }}
              </span>
              <span>F5.1 {{ $store.state.app.selectedModelName }} Share (%) </span>
            </v-flex>

            <template
              v-if="
                $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                  .products.HS6_Code.length !== 1
              "
            >
              <v-col sm="2">
                <v-tooltip left color="success">
                  <template v-slot:activator="{on, attrs}">
                    <v-text-field
                      v-model="min"
                      outlined
                      hide-details
                      single-line
                      :disabled="$store.state.tradeDSM.updatingMainFilters"
                      dense
                      class="caption ml-10"
                      v-on="on"
                      @change="update_state([min, max], false)"
                      @input="register_change"
                    />
                  </template>
                  <span>
                    {{ prov_min_hover_f }}
                  </span>
                </v-tooltip>
              </v-col>
              <v-col sm="2">
                <v-tooltip bottom color="success">
                  <template v-slot:activator="{on, attrs}">
                    <v-text-field
                      v-model="max"
                      outlined
                      hide-details
                      single-line
                      :disabled="$store.state.tradeDSM.updatingMainFilters"
                      dense
                      v-on="on"
                      class="caption mr-11"
                      @change="update_state([min, max], false)"
                      @input="register_change"
                    />
                  </template>
                  <span>{{ prov_max_hover_f }}</span>
                </v-tooltip>
              </v-col>
              <v-col sm="2" v-show="prov_update_button_active === true">
                <v-tooltip top color="success" max-width="200px">
                  <template v-slot:activator="{on, attrs}">
                    <v-btn
                      @click="update_state([min, max], true)"
                      x-small
                      class="yellow d-inline"
                      v-on="on"
                    >
                      Update
                    </v-btn>
                  </template>
                  <span
                    >Click on [UPDATE] to refresh summary info with your latest filter
                    changes. To extract updated results for current filter changes select
                    [APPLY] at the top of this form.</span
                  >
                </v-tooltip>
              </v-col>
            </template>
            <template v-else>
              <!--              <v-flex class="green&#45;&#45;text ml-12">-->
              <v-tooltip top color="success">
                <template v-slot:activator="{on, attrs}">
                  <div class="ml-5 pa-0 pt-1" v-on="on">
                    {{
                      Math.round(
                        $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                          .query_results['TW_Share_Prov'] * 10000,
                      ) / 100
                    }}%
                  </div>
                </template>
                <span>{{ p1c1_share_hover }}</span>
              </v-tooltip>
              <!--              </v-flex>-->
            </template>
          </v-row>
        </v-container>
      </v-main>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import {mapMutations} from 'vuex';
import {eventBus} from '@/main';

export default {
  name: 'filter_group',
  props: {
    filter_name: String,
    filter_data: Object,
    advanced: Boolean,
    update_function: Function,
  },
  mounted() {
    this.share = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.PROVINCIAL_FILTER_VALUE;
    this.max = this.share[1];
    this.min = this.share[0];
    this.before_update_min = this.min;
    this.before_update_max = this.max;
  },
  data: function() {
    return {
      first_query: true,
      share: [0, 100],
      min: 0.0,
      max: 100.0,
      prov_update_button_active: false,
      before_update_min: null,
      before_update_max: null,
    };
  },
  watch: {
    filter_value_changed(v) {
      this.share = v;
      this.min = v[0];
      this.max = v[1];
      this.min = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.PROVINCIAL_FILTER_VALUE[0];
      this.max = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.PROVINCIAL_FILTER_VALUE[1];
      // this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty =true
    },
  },
  computed: {
    p1c1_share_hover() {
      let product = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .selections.products.HS6_Code[0];
      // let market = this.codeToMarket(this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code[0])

      // let txt = ""
      // if (product.length>2) {
      //   txt = txt + product
      // }
      //
      // if (product.length>2 && market.length>2) {
      //   txt = txt + " and "
      // }
      //
      // if (market.length>2) {
      //   txt = txt + market
      // }

      return `The only outcome for ${product} is ${Math.round(
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
          'TW_Share_Prov'
        ] * 10000,
      ) / 100}%`;
    },
    prov_min_hover_f() {
      return `Enter a value >= ${this.before_update_min}%`;
    },
    prov_max_hover_f() {
      return `Enter a value <= ${this.before_update_max}%`;
    },
    filter_value_changed() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .PROVINCIAL_FILTER_VALUE;
    },
  },
  methods: {
    ...mapMutations(['set_provincial_share_filter']),

    register_change() {
      this.prov_update_button_active = true;
      eventBus.$emit('FILTER_CHANGED');
    },
    update_state(range, run_update_filers_selection = true) {
      // let floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
      let do_the_run_min = false;
      let do_the_run_max = false;

      if (
        // this.min < this.before_update_min ||
        // this.min > this.before_update_max ||
        this.min > this.max ||
        isNaN(Number(this.min))
      ) {
        this.min = this.before_update_min;
      } else {
        do_the_run_min = true;
      }

      if (
        // this.max < this.before_update_min ||
        // this.max > this.before_update_max ||
        this.max < this.min ||
        isNaN(Number(this.max))
      ) {
        this.max = this.before_update_max;
      } else {
        do_the_run_max = true;
      }

      if (do_the_run_min === true && do_the_run_max === true) {
        this.set_provincial_share_filter(range.map(v => parseFloat(v, 10)));
        this.min = range[0];
        this.max = range[1];
        this.prov_update_button_active = true;
        eventBus.$emit('FILTER_CHANGED');
        if (run_update_filers_selection === true) {
          this.update_filters_selection(true).then(() => {
            this.before_update_min = this.min;
            this.before_update_max = this.max;
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.filter_heading {
  font-weight: bold;
}

.filter_sub {
  margin-left: 10px;
}
</style>
